import React$1 from 'react';

const RightSmall = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "17"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M1-.414L9.414 8 1 16.414-.414 15l6.999-7-6.999-7z"
}));

export default RightSmall;
